module.exports = __webpack_public_path__ + "media/images/man_loitering_on_a_present-7c3e10cd1eae0cc3ac6b0d689bbeea41.svg";